import cloudFunctionApi from '../../../../cloudfunctions';
import firebaseApi from '../../../../firebase/firebaseApi';
import {
	useUserDetailsContext,
	useUserAuthContext,
} from '../../../../providers/UserProvider';
import { LoadingDots } from '../../../Management/subcomponents/LoadingDots';
import { SitesTab } from './SitesTab';

export const SitesWrapper = (): JSX.Element => {
	const userDetails = useUserDetailsContext();
	const user = useUserAuthContext();

	return userDetails === null || user === null ? (
		<LoadingDots />
	) : (
		<SitesTab
			firebaseApi={firebaseApi}
			cloudFunctionApi={cloudFunctionApi}
			userDetails={userDetails}
			user={user}
		/>
	);
};
